import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  landingStoryblokComponents,
  MarketingCarousel,
} from '@cinch-nx/landing-ui-shared'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import { ComponentLayouts } from '@cinch-nx/storyblok-utils'
import { Table } from '../table'

const {
  HighlightsSection,
  Table: StoryblokTable,
  ...slimComponents
}: ComponentMap = {
  ...landingStoryblokComponents,
  LoopingCarousel: MarketingCarousel,
  Table,
  ...globalStoryblokComponents,
}

export const servicingStoryblokComponents: ComponentLayouts = {
  noWrapper: { Table: StoryblokTable },
  fullWidthWrapper: { HighlightsSection },
  slimWrapper: slimComponents,
}
